import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const handleNavClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  };

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Awareness', path: '/awareness' },
    { name: 'Prevention', path: '/prevention' },
    { name: 'Hospitals', path: '/hospital-directory' },
    { name: 'About', path: '/about' },
    { name: 'FAQ', path: '/faq' },
  ];

  // Check if we're on homepage and not scrolled
  const isHomepageTop = location.pathname === '/' && !isScrolled;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || location.pathname !== '/' ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" onClick={handleNavClick} className="flex items-center gap-3 group">
            <img 
              src="https://public.readdy.ai/ai/img_res/835b90e7-15d7-47fb-a5b4-0e6c183bf516.png" 
              alt="CerviShield Logo" 
              className="h-10 w-10 object-contain transition-transform duration-300 group-hover:scale-110"
            />
            <span className={`text-xl font-bold font-display transition-colors duration-300 ${
              isHomepageTop ? 'text-white' : 'text-gray-800'
            }`}>
              CerviShield
            </span>
          </Link>

          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={handleNavClick}
                className={`text-sm font-medium transition-all duration-300 hover:text-primary relative group whitespace-nowrap ${
                  isHomepageTop ? 'text-white' : 'text-gray-700'
                } ${location.pathname === link.path ? 'text-primary' : ''}`}
              >
                {link.name}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-primary transition-all duration-300 group-hover:w-full"></span>
              </Link>
            ))}
          </div>

          <div className="hidden lg:flex items-center gap-4">
            <Link
              to="/emergency"
              onClick={handleNavClick}
              className="px-5 py-2.5 bg-secondary text-white rounded-full text-sm font-semibold hover:bg-secondary/90 transition-all duration-300 flex items-center gap-2 animate-pulse-slow whitespace-nowrap cursor-pointer"
            >
              <i className="ri-alarm-warning-line"></i>
              Emergency
            </Link>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden text-2xl transition-colors duration-300 cursor-pointer ${
              isHomepageTop ? 'text-white' : 'text-gray-800'
            }`}
          >
            <i className={isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 bg-white rounded-lg shadow-lg">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={handleNavClick}
                className={`block px-4 py-3 text-gray-700 hover:bg-primary/10 hover:text-primary transition-colors duration-300 cursor-pointer ${
                  location.pathname === link.path ? 'bg-primary/10 text-primary' : ''
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/emergency"
              onClick={handleNavClick}
              className="block mx-4 mt-3 px-4 py-3 bg-secondary text-white rounded-lg text-center font-semibold hover:bg-secondary/90 transition-colors duration-300 cursor-pointer"
            >
              <i className="ri-alarm-warning-line mr-2"></i>
              Emergency Guidance
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
